import { useMemo } from 'react';
import { DateTime, Duration } from 'luxon';
import TimelineUtil from "../TimelineUtil.js";
/**
 * @callback DateFormatter
 * @param {DateTime} dateTime 
 */
const day = Duration.fromObject({
  day: 1,
  minute: 1
}).valueOf();
const month = Duration.fromObject({
  month: 1,
  minute: 1
}).valueOf();
const year = Duration.fromObject({
  year: 1,
  minute: 1
}).valueOf();
export default function useTimelineAxis(opts) {
  const {
    range,
    numTicks = 5,
    numSubTicks = 3
  } = opts;
  const {
    ticks
  } = useMemo(() => {
    const start = TimelineUtil.coerceDateTime(range.start);
    const end = TimelineUtil.coerceDateTime(range.end).plus({
      minutes: 1
    }).startOf('minute');
    const rangeMs = end && start ? end - start : 0;

    /**
     * @type {DateFormatter}
     */
    let dateFormatter = dateTime => dateTime.toLocaleString(DateTime.DATETIME_FULL);
    if (rangeMs <= day) {
      dateFormatter = dateTime => dateTime.toLocaleString({
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } else if (rangeMs <= month) {
      dateFormatter = dateTime => dateTime.toLocaleString({
        month: 'short',
        day: 'numeric'
      });
    } else if (rangeMs <= year) {
      dateFormatter = dateTime => dateTime.toLocaleString({
        month: 'short',
        year: '2-digit'
      });
    } else {
      dateFormatter = dateTime => dateTime.toLocaleString({
        year: 'numeric'
      });
    }
    const totalTicks = numTicks + numSubTicks * (numTicks + 1);
    const step = rangeMs / (totalTicks + 1);
    const ticks = [{
      date: start,
      isTick: false,
      isSubTick: false,
      label: dateFormatter(start),
      key: start.toISO()
    }];
    let subTickCounter = 0;
    for (let i = 1; i <= totalTicks; i++) {
      const date = start.plus({
        milliseconds: step * i
      });
      const isTick = subTickCounter === numSubTicks;
      const isSubTick = !isTick;
      if (isTick) {
        subTickCounter = 0;
      } else {
        ++subTickCounter;
      }
      ticks.push({
        date,
        isTick,
        isSubTick,
        label: dateFormatter(date),
        key: date.toISO()
      });
    }
    ticks.push({
      date: end,
      isTick: false,
      isSubTick: false,
      label: dateFormatter(end),
      key: end.toISO()
    });
    return {
      ticks
    };
  }, [range, numTicks, numSubTicks]);
  return {
    ticks
  };
}